var _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _path8, _polygon2, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrantixmedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 284 100",
    style: {
      enableBackground: "new 0 0 284 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "frantixmedia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.3,78.2L80.3,78.2c-0.5,1.7-0.9,4-1.3,5.6l-1.4,5.8H83l-1.5-5.8C81.2,82.2,80.7,79.9,80.3,78.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.8,90.9L160.8,90.9c-0.6,1.6-1.2,3.1-2,4.9l-1.7,4.2h7.7l-1.9-4.2C162.1,94,161.5,92.6,160.8,90.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.6,100l-4.9-9.7c-1.6-3-2.9-6.1-4.2-9.2h-0.1c0.2,3.4,0.3,7.3,0.3,12.1v6.8H109.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7,81.6c0-2.4-1.5-3.8-4.2-3.9c-0.8,0-1.6,0-2.3,0.2v7.7h2C59,85.7,60.7,84,60.7,81.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "75.3,100 85.4,100 83.8,94 76.8,94 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2,100h7c-0.6-1.9-1.1-3.7-1.4-5.6C59,91,58,90,55.7,90h-1.5V100z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5,78.2L272.5,78.2c-0.4,1.7-0.9,4-1.3,5.6l-1.5,5.8h5.4l-1.5-5.8C273.3,82.2,272.9,79.9,272.5,78.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.6,80c-0.8,3.3-1.8,7-2.6,9.9l-3,10.1h6.4l-0.4-9.4c-0.1-3.1-0.3-6.9-0.2-10.6L195.6,80z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0v100h28.6V73.5h15.2v4.9h-9.3v6.5h8.7v4.8h-8.7V100h13.8V73.9c2.5-0.4,5-0.6,7.5-0.6c3.7,0,6.5,0.6,8.4,2.1 c1.7,1.4,2.5,3.5,2.4,5.7c0,3-1.9,5.7-4.6,6.7V88c1.9,0.8,2.9,2.6,3.6,5.2s1.3,5.3,1.8,6.8h2.1l7.4-26.5h7.6l7.3,26.5h3.7V73.5h6.5 l5.2,10.2c1.5,2.9,2.8,5.9,4,8.9h0.1c-0.3-3.4-0.5-7.4-0.5-11.8v-7.4h5.4V100h9.7V78.6h-6.6v-5.1h19.2v5.1h-6.7V100h9.8V73.5h5.9 V100h3.4l6.6-13.1l-6.8-13.4h6.6l2.1,5c0.7,1.6,1.2,3,1.8,4.5h0.1c0.6-1.7,1.1-3,1.6-4.5l2-5h6.5l-6.9,13.4l6.9,13.1h2.7l1.8-26.5 h7.4l2.5,9.3c0.8,3.2,1.6,6.5,2.2,9.7h0.1c0.6-3.1,1.5-6.6,2.3-9.7l2.7-9.3h7.3L202,100h4.5V73.5h15.3v4.9h-9.4v5.9h8.9v4.8h-8.9 v6.8h10v4.1h4V73.9c2.5-0.4,4.9-0.6,7.4-0.6c4.7,0,7.8,0.9,10.1,2.8c2.7,2.1,4.3,5.5,4.3,10.5c0,5.3-1.8,9-4.3,11.2 c-1.2,1-2.6,1.8-4.1,2.2h12.3V73.5h5.9V100h3.4l7.4-26.5h7.6l7.4,26.5h0.2V0H0z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.5,100 277.6,100 276,94 269,94 "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M242.1,86.7c0-5.7-2.8-8.8-7.4-8.8c-0.8,0-1.5,0-2.3,0.2v18.2c0.6,0.1,1.2,0.1,1.8,0.1C238.9,96.4,242.1,93.5,242.1,86.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5,80L180.5,80c-0.2,3.5-0.4,7.5-0.5,10.7l-0.4,9.3h5.9l-2.6-9.9C181.9,87.2,181.1,83.4,180.5,80z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrantixmedia);
export default __webpack_public_path__ + "static/media/frantixmedia.a41d930e7dd43a81a8508e409e98b2cd.svg";
export { ForwardRef as ReactComponent };